import { PieChart } from '@/common/dashboard/charts/PieChart';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useEffect, useState } from 'react';

export const McoPhsCapPieChart = ({ formValues }) => {

    const { mcoInvId, prodIds, periodIds } = formValues;

    const rsrc = useRsrc();

    const [data, setData] = useState([]);

    useEffect(() => {
        if (!mcoInvId) {
            return;
        }

        const reqParam = {
            mcoInvId,
            prodIds,
            periodIds
        };

        rsrc.data('sc', 'MCO_PHS_CAP_PIE_CHART_DATA_PLUGIN', reqParam).then(res => {
            setData(res);
        });
    }, [mcoInvId, prodIds, periodIds]);

    if (!data) {
        return null;
    }

    return (
        <>
            <PieChart 
                data={data}
            />
        </>
    )
}